import BaseService from "src/packages/BaseService";

export default class ClientService extends BaseService {
	static get className() {
		return "client";
	}
};
